<template>
  <div>
    <div>
      <div>
        <div>
          <!-- 查询条件转货 -->
          <div>
            <div ref="searchBox" class="formBox margbot">
              <el-form :inline="true" :model="formData" class="demo-form-inline" label-width="100px"  size="mini">
                <div class="formItemBox">
                <el-form-item label="转货单号:">
                  <el-input v-model="formData.changeNo" placeholder="请输入转货单号" size="mini" >
                  </el-input>
                </el-form-item>
                <el-form-item label="转货时间:">
                  <div style="display: flex;">
                  <el-date-picker v-model="formData.approverDateStart" size="mini" placeholder="请选择" type='datetime'
                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                  -
                  <el-date-picker v-model="formData.approverDateEnd" size="mini" type="datetime" placeholder="请选择"
                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                  </div>
                </el-form-item>
                <el-form-item label="原一级货主:">
                  <el-select v-model="formData.oldPrimaryCustomerId" size="mini" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item,index) in SHData" :key="index" :label="item.custerName"
                      :value="item.taxpayerNumber"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="原二级货主:">
                  <el-select v-model="formData.oldSecondaryCustomerId" size="mini" filterable placeholder="请选择"
                    clearable>
                    <el-option v-for="(item,index) in SHData" :key="index" :label="item.custerName"
                      :value="item.taxpayerNumber"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="货物类型:">
                  <el-select v-model="formData.productType" size="mini" placeholder="请选择" clearable>
                    <el-option v-for="item in HwData" :key="item.productType" :label="item.productTypeName"
                      :value="item.productType"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="现一级货主:">
                  <el-select v-model="formData.newPrimaryCustomerId" size="mini" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item,index) in SHData" :key="index" :label="item.custerName"
                      :value="item.taxpayerNumber"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="现二级货主:">
                  <el-select v-model="formData.newSecondaryCustomerId" size="mini" filterable placeholder="请选择"
                    clearable>
                    <el-option v-for="(item,index) in SHData" :key="index" :label="item.custerName"
                      :value="item.taxpayerNumber"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="转货类型:">
                  <el-select v-model="formData.changeType" size="mini" placeholder="请选择" clearable>
                    <el-option v-for="item in changeTypeOption" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
               </div>
                <el-form-item>
                  <el-button type="primary" size="mini" @click="chaxun" btnCode="00ZM0E0B00" v-if="btnFlg[39]">查询
                  </el-button>
                  <el-button type="primary" size="mini" @click="chongzhi" btnCode="00ZM0E0C00" v-if="btnFlg[40]">重置
                  </el-button>
                  <el-button type="primary" size="mini" @click="chexiao" btnCode="00ZM0E0D00" v-if="btnFlg[41]">撤销
                  </el-button>
                  <el-button type="primary" size="mini" @click="daochu" btnCode="00ZM0E0E00" v-if="btnFlg[42]">导出
                  </el-button>

                </el-form-item>
                <el-form-item>
                  <span>总吨数：<span
                      style="color:red">{{Number(allWeight) }}</span>&nbsp;&nbsp;吨</span>&nbsp;&nbsp;&nbsp;&nbsp;
                  <span>总件数：<span style="color:red">{{ number }}</span>&nbsp;&nbsp;件</span>
                </el-form-item>
              </el-form>
            </div>

            <div :style="{ height: h }">
              <el-table height="100%" style="width:100%" size="mini" :data="detailsData" class="tableComent"
                :header-cell-style="{ background: '#F5F5F5',color: 'black',}" border center bordersize="mini"
                highlight-current-row @row-click='dianjixuanzhong'>
                <!-- <el-table-column
                prop="changeId"
                label="转货单号"
                align="center"
                width="120"
                ></el-table-column> -->
                <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
                <!-- <el-table-column
                  prop="danju"
                  label="操作"
                  align="center"
                  width="150"
                >
                <template slot-scope="scope">
                  <div>
                    <el-button
                    type="text"
                    size="small"
                    @click="handleClick(scope.row)"
                    >查看单据</el-button>
                  </div>
                </template>
                   <el-image
                    v-for="(item,index) in imgList.loadingImgs" :src="item.fileUrlOSS" :key="index"
                    style="width: 260px; height: 200px"
                   :preview-src-list="getSrcList(index,loadingImgs)">
                  </el-image>
                </el-table-column> -->
                <el-table-column prop="changeTypeName" label="转货类型" align="center" :show-overflow-tooltip="true"
                  width="100"></el-table-column>
                <el-table-column prop="approverDate" label="转货时间" align="center" :formatter="dateTimeFormat"
                  :show-overflow-tooltip="true" width="180"></el-table-column>
                <el-table-column prop="oldPrimaryCustomerName" :show-overflow-tooltip="true" label="原一级货主"
                  align="center" width="220"></el-table-column>
                <el-table-column prop="oldSecondaryCustomerName" :show-overflow-tooltip="true" label="原二级货主"
                  align="center" width="220"></el-table-column>
                <el-table-column prop="newPrimaryCustomerName" :show-overflow-tooltip="true" label="现一级货主"
                  align="center" width="220"></el-table-column>
                <el-table-column prop="newSecondaryCustomerName" :show-overflow-tooltip="true" label="现二级货主"
                  align="center" width="220"></el-table-column>
                <el-table-column prop="customerChangNo" :show-overflow-tooltip="true" label="货主转货单编号" align="center"
                  width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库日期" align="center"
                  width="100"></el-table-column>

                <el-table-column prop="productTypeName" :show-overflow-tooltip="true" label="货物类型" align="center"
                  width="120"></el-table-column>
                <el-table-column prop="steelMillName" :show-overflow-tooltip="true" label="产地" align="center"
                  width="100"></el-table-column>
                <el-table-column prop="specification" label="规格" align="center" width="120"></el-table-column>
                <el-table-column prop="model" label="材质" align="center" width="120"></el-table-column>
                <el-table-column prop="number" label="件数" align="center" width="70" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="allWeight" label="总重量(吨)" align="center" width="120">
                </el-table-column>
                <el-table-column prop="weight" label="理重(吨)" align="center" width="120">
                </el-table-column>
                <el-table-column prop="weighingWeight" label="过磅净重(吨)" align="center" width="120">
                </el-table-column>
                <el-table-column prop="weighingDate" label="净重过磅时间" align="center" :show-overflow-tooltip="true"
                  width="180">
                </el-table-column>
                <!-- <el-table-column
                prop="sourceName"
                label="数据来源"
                align="center"
                width="120"
                ></el-table-column> -->
                <!-- <el-table-column
                prop="changeBillNo"
                label="转货提单号"
                :show-overflow-tooltip="true"
                align="center"
                width="250"
                ></el-table-column> -->
                <el-table-column prop="changeNo" label="转货单号" align="center" width="220" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="approverName" label="操作人" :show-overflow-tooltip="true" align="center"
                  width="150"></el-table-column>
                <!-- <el-table-column
                prop="approverName"
                label="审核人"
                align="center"
                      :show-overflow-tooltip="true"
                width="200"
                ></el-table-column>
                <el-table-column
                prop="changeStatus"
                label="审核结果"
                      :show-overflow-tooltip="true"
                align="center"
                width="120"
                ></el-table-column>
                <el-table-column
                prop="approverReject"
                label="审核意见"
                align="center"
                width="120"
                >
                  <template v-slot="scope">
                    <div>
                      <el-button
                      type="text"
                      size="small"
                      @click="chakanshenhe(scope.row)"
                      >查看</el-button>
                  </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="applicantDate"
                  :show-overflow-tooltip="true"
                  label="转货时间"
                  align="center"
                  width="200"
                  :formatter="dateTimeFormat"
                ></el-table-column> -->

              </el-table>
            </div>
          </div>
          <!-- 分页-->
          <div class="pags">
            <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
              :page-size="pageInfo.pageSize" :page-sizes="[10,20,30,40,50]"
              layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total">
            </el-pagination>
          </div>
        </div>
        <!-- 查看单据 -->
        <div class="addMarkBox">
          <el-dialog title="查看凭证" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="80%" center>
            <div class="img_box" v-if="!imgFlag">
              <div>暂未上传凭证</div>
            </div>
            <div class="box1" v-else>
              <div class="leftbox img_box">
                <div v-for="(item,index) in imgData" :key="index" @click="handChange(item.url,item.urlPrimary)"
                  class="imgbox">
                  <div v-if="item.urlPrimary.substring(item.urlPrimary.length-3)==='pdf'">
                    <!-- <img src="@/assets/images/pdf.jpg"> -->
                    <!-- <i v-if="seen" class="el-icon-delete" @click="delImg(item)" btnCode=""></i> -->
                  </div>
                  <div v-else>
                    <img :src="item.url" alt />
                    <!-- <i v-if="seen" class="el-icon-delete" @click="delImg(item)" btnCode=""></i> -->
                  </div>
                </div>
              </div>
              <div class="rightbox">
                <div v-if="pdfFlag" class="pdfbox">
                  <iframe :src="path" frameborder="0" style="width: 100%; height:100%"></iframe>
                </div>
                <div class="imgDialog" v-else>
                  <img :src="path" alt />
                </div>
              </div>
            </div>
            <div style="width:80px;margin:15px auto;">
              <el-button type="primary" @click="lookQuXiao">取消</el-button>
            </div>
          </el-dialog>
        </div>

        <!-- <el-dialog title="查看现场图片" :visible.sync="dialogVisibleImg" width="35%">
        <div class="demo-image__preview"  v-if="!lookFlag" style="display: flex">
          <el-image
            :preview-src-list="getSrcList()"
            fit="cover"
            v-for="(item, index) in imgList"
            :key="index"
            style="
              width: 100px;
              height: 100px;
              display: block;
              margin-left: 5px;
            "
            :src="item"
          >
          </el-image>
        </div>
        <span v-if="lookFlag">暂无图片</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleImg = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisibleImg = false"
            >确 定</el-button>
        </span>
      </el-dialog> -->
        <!-- 审核意见 -->
        <el-dialog title="查看审核意见" :visible.sync="dialogShenheVisible" width="35%">
          <div class="demo-image__preview" v-if="!lookApproverReject" style="display: flex">
            {{shenheYijian}}
          </div>
          <span v-if="lookApproverReject">暂无审核意见</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogShenheVisible = false">关 闭</el-button>
            <!-- <el-button type="primary" @click="dialogVisibleImg = false"
            >确 定</el-button> -->
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getRelationCustomer,
  zidian,
  getImgShow,
  getSBillFileUrl,
  getInChangeList,
  getInChangeNumber,
  revokeInChange,
  getVirtualBalingList
} from '@/api/wms-stock'
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  exportExcel
} from '@/utils/fileDown.js'
import {
  dateTimeFormat
} from '@/utils/util'

export default {
  name: 'ZHRecord',
  data () {
    return {
      path: '',
      imgFlag: true,
      imgData: [],
      pdfFlag: false,
      addMarkLookBox: false,
      dialogVisibleImg: false,
      lookFlag: false,
      imgList: [],
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      total: 0,
      formData: {
        changeNo: '',
        changeStatus: '',
        approverDateStart: '',
        approverDateEnd: '',
        oldPrimaryCustomerId: '',
        oldSecondaryCustomerId: '',
        newPrimaryCustomerId: '',
        newSecondaryCustomerId: '',
        productType: '',
        changeBillNo: '',
        source: '',
        changeType: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      SHData: [],
      detailsData: [],
      SHjgData: [{
        value: 1,
        label: '同意'
      },
      {
        value: 2,
        label: '驳回'
      }
      ],
      HwData: [],
      ShData: [],
      SjData: [],
      btnArr: [
        '00ZP007B001',
        '00ZP007B002',
        '00ZP007B003',
        '00ZP007B004',
        '00ZP007B005',
        '00ZP007B006',
        '00ZP007B007',
        '00ZP007B008',
        '00ZP007B009',
        '00ZP007B00A',
        '00ZP007B00B',
        '00ZP007B00C',
        '00ZP007B00D',
        '00ZP007B00E',
        '00ZP007B00F',
        '00ZP007B00G',
        '00ZP007B00H',
        '00ZP007B00I',
        '00ZP007B00J',
        '00ZP007B00K',
        '00ZP007B00L',
        '00ZP007B00M',
        '00ZP007B00N',
        '00ZP007B00O',
        '00ZP007B00P',
        '00ZP007B00Q',
        '00ZP007B00R',
        '00ZP007B00S',
        '00ZP007B00T',
        '00ZP007B00U',
        '00ZM0E0100',
        '00ZM0E0200',
        '00ZM0E0300',
        '00ZM0E0400',
        '00ZM0E0500',
        '00ZM0E0600',
        '00ZM0E0700',
        '00ZM0E0800',
        // '00ZM0E0900',
        '00ZM0E0A00',
        '00ZM0E0B00',
        '00ZM0E0C00',
        '00ZM0E0D00',
        '00ZM0E0E00',
        '00ZM0E0F00',
        '00ZM0E0G00',
        '00ZM0E0H00'
      ],
      btnFlg: [],
      allWeight: 0,
      number: 0,
      h: '400px',
      shenheYijian: '',
      dialogShenheVisible: false,
      lookApproverReject: false,
      changeTypeOption: [{
        id: 1,
        name: '转货'
      },
      {
        id: 2,
        name: '回购'
      },
      {
        id: 3,
        name: '钢厂转货'
      }

      ],
      xuanzhongArr: null
    }
  },
  props: {
    ZHVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },

    getInChangeNumbers () {
      getInChangeNumber({
        ...this.formData,
        ...this.pageInfo
      })
        .then(res => {
          console.log(res)
          this.allWeight = parseFloat(res.totalAllWeight.toFixed(6))
          this.number = res.totalNumber
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 删除凭证
    // delImg (item) {
    //   this.$confirm('确定删除图片?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   })
    //     .then(() => {
    //       updateImage({
    //         imgId: item.imgId // 变更图片表id
    //       })
    //         .then(res => {
    //           DonMessage.success('操作成功!')
    //           this.getImgShowB()
    //         })
    //         .catch(err => {
    //           DonMessage.error(err.message)
    //         })
    //     })
    //     .catch(() => {})
    // },
    // 查看凭证-取消
    lookQuXiao () {
      this.addMarkLookBox = false
    },
    // 查看凭证-放大
    handChange (url, urlPrimary) {
      console.log(url, 2)
      this.path = url
      let str = urlPrimary.substring(urlPrimary.length - 3)
      if (str === 'pdf') {
        this.pdfFlag = true
      } else {
        this.pdfFlag = false
      }
      console.log(str)
      // this.dialogVisible = true
    },
    chakanshenhe (row) {
      this.dialogShenheVisible = true
      this.shenheYijian = row.approverReject
    },
    // 点击凭证放大
    getSrcList (index) {
      return this.imgList.slice(index).concat(this.imgList.slice(0, index))
    },
    // 查看图片
    handleClick (row) {
      this.getImgShowB(row)
    },
    getImgShowB (row) {
      // let params = {
      //   businessId: this.turnGoodsTableList[0].stockSummaryId,
      //   businessType: 'empty_stock_summary'
      // }
      getImgShow({
        businessId: row.changeId,
        businessType: 'empty_change'
      })
        .then((res) => {
          console.log(res)
          this.imgData = []
          this.imgFlag = true
          if (res.length < 1) {
            this.imgFlag = false
            return
          }
          this.imgData = res
          // this.pdfFlag = false
          this.seen3 = false
          this.seen2 = true

          // this.imgList = []
          if (row.sourceName == '手动') {
            // this.dialogVisibleImg = true
            // this.lookFlag = false
            // res.forEach((item, index) => {
            //   this.imgList.push(item.url)
            // })
            this.addMarkLookBox = true

            if (this.imgData[0].urlPrimary.substring(this.imgData[0].urlPrimary.length - 3) === 'pdf') {
              this.pdfFlag = true
              // this.path=this.imgData[0].urlPrimary
            } else {
              this.pdfFlag = false
              // this.path=this.imgData[0].url
            }
            this.path = this.imgData[0].url
          } else {
            let formData = new FormData()
            formData.append('url', res[0].urlPrimary)
            getSBillFileUrl(formData).then(res => {
              this.$router.push({
                // 核心语句
                path: '/pdf', // 跳转的路径
                query: {
                  // 路由传参时push和query搭配使用 ，作用时传递参数
                  path: res
                }
              })
            })
          }

          // if (this.imgList.length == 0) {
          //   this.lookFlag = true
          // }
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 分页
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.getInChangeLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.getInChangeLists()
    },
    chaxun () {
      this.getInChangeLists()
    },
    chongzhi () {
      this.formData.changeNo = ''
      this.formData.approverDateStart = ''
      this.formData.approverDateEnd = ''
      this.formData.oldPrimaryCustomerId = ''
      this.formData.oldSecondaryCustomerId = ''
      this.formData.newPrimaryCustomerId = ''
      this.formData.newSecondaryCustomerId = ''
      this.formData.productType = ''
      this.formData.changeBillNo = ''
      this.formData.source = ''
      this.formData.changeStatus = ''
      this.formData.changeType = ''
      this.getInChangeLists()
    },
    // 导出
    daochu () {
      this.isDisableYH = true
      setTimeout(() => {
        this.isDisableYH = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
      let form = {
        changeNo: this.formData.changeNo,
        approverDateStart: this.formData.approverDateStart,
        approverDateEnd: this.formData.approverDateEnd,
        oldPrimaryCustomerId: this.formData.oldPrimaryCustomerId,
        oldSecondaryCustomerId: this.formData.oldSecondaryCustomerId,
        newPrimaryCustomerId: this.formData.newPrimaryCustomerId,
        newSecondaryCustomerId: this.formData.newSecondaryCustomerId,
        productType: this.formData.productType,
        changeBillNo: this.formData.changeBillNo,
        source: this.formData.source,
        changeStatus: this.formData.changeStatus,
        changeType: this.formData.changeType
      }
      // fetch(
      exportExcel(
        this.global.wmsStockName +
          '/stockExpInfo/exportInChangeList',
        form,
        '转货明细信息表'
      )
    },
    // 撤销
    chexiao () {
      if (this.xuanzhongArr == null) {
        this.$message({
          message: '请选择一条数据',
          type: 'error'
        })
        return
      }
      this.$confirm('确定撤销转货吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        revokeInChange({
          changeDetailId: this.xuanzhongArr.changeDetailId // 主键id
        }).then((res) => {
          this.$message.success('撤销成功')
          this.chaxun()
        }).catch((err) => {
          this.$message.error(err.message)
        })
      }).catch(() => {})
    },
    // 列表
    getInChangeLists () {
      getInChangeList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        changeNo: this.formData.changeNo,
        approverDateStart: this.formData.approverDateStart,
        approverDateEnd: this.formData.approverDateEnd,
        oldPrimaryCustomerId: this.formData.oldPrimaryCustomerId,
        oldSecondaryCustomerId: this.formData.oldSecondaryCustomerId,
        newPrimaryCustomerId: this.formData.newPrimaryCustomerId,
        newSecondaryCustomerId: this.formData.newSecondaryCustomerId,
        productType: this.formData.productType,
        changeBillNo: this.formData.changeBillNo,
        source: this.formData.source,
        changeStatus: this.formData.changeStatus,
        changeType: this.formData.changeType
      })
        .then(res => {
          console.log(res)
          this.detailsData = res.list
          this.total = res.total
          this.xuanzhongArr = null
          this.detailsData.forEach(item => {
            item.allWeight = parseFloat(Number(item.allWeight).toFixed(6))
            item.weight = parseFloat(Number(item.weight).toFixed(6))
          })
          this.getInChangeNumbers()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          // console.log(res)
          this.SHData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 货物类型
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.HwData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // zidians () {
    //   zidian({
    //     groupNo: 'thread_product_type'
    //   })
    //     .then((res) => {
    //       // console.log(res)
    //       this.HwData = res
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     })
    // },
    zidiansj () {
      zidian({
        groupNo: 'source'
      })
        .then((res) => {
          // console.log(res)
          this.SjData = res
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/recordQuery')
    this.getInChangeLists()
    this.getRelationCustomerS()
    this.zidiansj()
    this.getInChangeNumbers()
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
    // this.changeExamines()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 205 + 'px'
  }
}

</script>

<style lang="less" scoped>
  .inpBox {
    .el-form-item {
      margin-left: 10px;
      margin-bottom: 0px;
    }
  }

  .box1 {
    overflow: hidden;
  }

  .leftbox {
    width: 250px;
    float: left;
    border-right: 1px solid black;
    height: calc(100vh - 250px);
    overflow-y: auto;
    // height:150px;
    // background-color:red;
    // .imgbox{
    //   border-bottom: 1px solid #ccc;
    // }
  }

  .rightbox {
    margin-left: 50px;
    width: 850px;
    float: left;

    // height:150px;
    // background-color:yellow;
    .pdfbox {
      height: calc(100vh - 250px);
    }
  }

  .img_box {

    // width: 100%;
    // display: flex;
    // flex-direction: row;
    // align-items: flex-start;
    // flex-wrap: wrap;
    div {
      widows: 150px;
      height: 160px;
      margin-right: 5px;
      // border: 1px dashed #ccc;
      // border-radius: 10px;
      padding: 2px;

      img {
        width: 150px;
        height: 150px;
        margin-left: 50px;
      }
    }
  }

  .imgDialog {
    width: 100%;
    // height:60vh;
    // overflow-x: scroll;
    // overflow-y: scroll;
    text-align: center;

    img {
      height: calc(100vh - 250px);
      // background-size: 100% 100%;
    }
  }
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}

 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
